import { differenceInCalendarDays } from 'date-fns';
import { getUTCDateFromServerDate } from 'utils/dateUtils';

const voucherHelpers = {
    HasVoucher: (voucherExpirationDate) => voucherExpirationDate ? true : false,
    VoucherExpiresInDays: (voucherExpirationDate) => voucherExpirationDate ? differenceInCalendarDays(getUTCDateFromServerDate(voucherExpirationDate), Date.now()) : null,
    VoucherExpiresWithin30Days: (voucherExpirationDate) => {
        var expiresInDays = voucherHelpers.VoucherExpiresInDays(voucherExpirationDate);

        return Number.isInteger(expiresInDays) && expiresInDays <= 30 && !voucherHelpers.VoucherExpired(voucherExpirationDate);
    },
    VoucherExpired: (voucherExpirationDate) => {
        var expiresInDays = voucherHelpers.VoucherExpiresInDays(voucherExpirationDate);

        return Number.isInteger(expiresInDays) && expiresInDays < 0;
    }
};

export default voucherHelpers;